/**
 * Reusable validation rules for react-hook-form.
 * Import and spread into register() options.
 *
 * Usage:
 *   const { register } = useForm();
 *   <input {...register('email', validationRules.email)} />
 */

export const validationRules = {
  email: {
    required: 'Email is required',
    pattern: {
      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: 'Please enter a valid email address',
    },
    maxLength: {
      value: 254,
      message: 'Email is too long',
    },
  },

  password: {
    required: 'Password is required',
    minLength: {
      value: 8,
      message: 'Password must be at least 8 characters',
    },
    maxLength: {
      value: 128,
      message: 'Password is too long',
    },
  },

  passwordStrong: {
    required: 'Password is required',
    minLength: {
      value: 8,
      message: 'Password must be at least 8 characters',
    },
    maxLength: {
      value: 128,
      message: 'Password is too long',
    },
    pattern: {
      value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])/,
      message: 'Must include uppercase, lowercase, number, and special character',
    },
  },

  required: (fieldName = 'This field') => ({
    required: `${fieldName} is required`,
  }),

  name: {
    required: 'Name is required',
    maxLength: {
      value: 100,
      message: 'Name is too long',
    },
    pattern: {
      value: /^[a-zA-Z\s'-]+$/,
      message: 'Name contains invalid characters',
    },
  },

  phone: {
    pattern: {
      value: /^\+?[\d\s()-]{7,20}$/,
      message: 'Please enter a valid phone number',
    },
  },

  domain: {
    required: 'Domain is required',
    pattern: {
      value: /^[a-z0-9-]+(\.[a-z0-9-]+)*\.[a-z]{2,}$/,
      message: 'Please enter a valid domain (e.g. example.com)',
    },
  },

  username: {
    required: 'Username is required',
    maxLength: {
      value: 100,
      message: 'Username is too long',
    },
    pattern: {
      value: /^[a-zA-Z0-9._-]+$/,
      message: 'Username can only contain letters, numbers, dots, hyphens, and underscores',
    },
  },

  mfaCode: {
    required: 'Verification code is required',
    pattern: {
      value: /^\d{6}$/,
      message: 'Code must be 6 digits',
    },
  },
};
